import React from 'react';

export const FAQPage: React.FC = () => {
  return (
      <div className="bg-gray-50 pt-32 pb-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
            <h1 className="text-3xl md:text-4xl font-bold text-go2-pink mb-8 text-center">
              NAJČEŠĆE POSTAVLJANA PITANJA
            </h1>
            
            <div className="prose prose-blue max-w-none text-gray-700">
              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">1. Šta je “Go2 Legende”?</h2>
              <p>“Go2 Legende” je program lojalnosti turističke agencije Go2 Event d.o.o.<br/>
              Što više putuješ sa Go2, više poena, popusta i pogodnosti dobijaš – i polako se penješ kroz nivoe: Putnik → Svetski putnik → Legenda.</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">2. Ko može da učestvuje u programu?</h2>
              <p>U programu mogu da učestvuju:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>punoletna fizička lica,</li>
                <li>sa prebivalištem ili boravištem u Republici Srbiji,</li>
                <li>koja putuju preko Go2 i prihvate pravila programa.</li>
              </ul>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">3. Kako se učlanjujem u program?</h2>
              <p>Članom programa postaješ automatski:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>kada prvi put rezervišeš i realizuješ putovanje sa Go2,</li>
                <li>i registruješ svoj nalog (na sajtu, u aplikaciji ili preko agencije).</li>
              </ul>
              <p>Nema članarine, učešće se zasniva na ostvarenoj potrošnji Organizatora.</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">4. Kako skupljam poene?</h2>
              <p>Poene dobijaš za svako realizovano putovanje sa Go2.</p>
              <p><strong>Osnovno pravilo: 1 EUR vrednosti aranžmana = 1 poen</strong></p>
              <p>Poeni se dodeljuju za:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>glavni aranžman (prevoz, smeštaj…)</li>
                <li>doplate uz aranžman (izleti, osiguranje, doplata za sobu…), osim tamo gde Go2 drugačije navede.</li>
              </ul>
              <p>Poeni se upisuju nakon što je putovanje plaćeno i realizovano.</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">5. Koliko vrede poeni?</h2>
              <p><strong>Osnovno pravilo: 100 poena = 5 EUR popusta</strong> na sledeće putovanje.</p>
              <p>Primer:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>500 poena = 25 EUR popusta</li>
                <li>1.000 poena = 50 EUR popusta</li>
              </ul>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">6. Koliki deo aranžmana mogu da platim poenima?</h2>
              <p>Zavisi od tvog nivoa u programu:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Putnik</strong>: poenima možeš da pokriješ do 20% vrednosti aranžmana</li>
                <li><strong>Svetski putnik</strong>: do 30%</li>
                <li><strong>Legenda</strong>: do 40%</li>
              </ul>
              <p>Ostatak se plaća standardno (kartica, uplata itd.).</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">7. Koliko dugo važe poeni?</h2>
              <p>Poeni važe 24 meseca od dana kada su dodeljeni.</p>
              <p>Ako ih ne iskoristiš u tom roku – automatski ističu i brišu se.</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">8. Šta su nivoi: Putnik, Svetski putnik, Legenda?</h2>
              <p>To su nivoi lojalnosti – što više putuješ i više trošiš kod Go2, tvoj status je viši:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Putnik</strong> – svako ko je barem jednom putovao sa Go2 u poslednje 2 godine.</li>
                <li><strong>Svetski putnik</strong> – ukupna potrošnja u poslednja 24 meseca je 800–1.499 EUR.</li>
                <li><strong>Legenda</strong> – ukupna potrošnja u poslednja 24 meseca je 1.500+ EUR.</li>
              </ul>
              <p>Viši nivo = više poena za svako naredno putovanje + veći deo aranžmana možeš da pokriješ poenima + dodatne pogodnosti.</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">9. Šta mi konkretno donose nivoi?</h2>
              <p><strong>Putnik</strong></p>
              <ul className="list-disc pl-5 space-y-1">
                <li>1 EUR = 1 poen</li>
                <li>poenima možeš da pokriješ do 20% aranžmana</li>
              </ul>
              <p className="mt-2"><strong>Svetski putnik</strong></p>
              <ul className="list-disc pl-5 space-y-1">
                <li>1 EUR = 1,2 poena (20% više poena)</li>
                <li>poenima možeš da pokriješ do 30% aranžmana</li>
                <li>posebne akcije i ponude samo za ovaj nivo</li>
              </ul>
              <p className="mt-2"><strong>Legenda</strong></p>
              <ul className="list-disc pl-5 space-y-1">
                <li>1 EUR = 1,4 poena (40% više poena)</li>
                <li>poenima možeš da pokriješ do 40% aranžmana</li>
                <li>specijalne pogodnosti (npr. gratis osiguranje ili izlet jednom godišnje, veće šanse u nagradnim igrama i sl.)</li>
              </ul>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">10. Da li poene mogu da prenesem na nekog drugog ili da tražim novac umesto popusta?</h2>
              <p>Ne.</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Poeni su vezani za tvoj nalog i lični su.</li>
                <li>Ne mogu se preneti na drugu osobu.</li>
                <li>Ne mogu se zameniti za gotovinu.</li>
                <li>Možeš ih koristiti isključivo kao popust na putovanja u skladu sa pravilima programa.</li>
              </ul>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">11. Šta se dešava sa poenima ako otkažem putovanje?</h2>
              <p>Ako dođe do otkazivanja:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>primenjuju se Opšti uslovi putovanja Go2 (visina storno troškova itd.),</li>
                <li>poeni dodeljeni za to putovanje se mogu korigovati ili poništiti, u skladu sa internim pravilima agencije.</li>
              </ul>
              <p>Tačan obračun zavisi od momenta i uslova otkazivanja.</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">12. Šta su “achievements” (dostignuća)?</h2>
              <p>To su posebne “misije” u okviru programa lojalnosti – slično kao achievements u igricama.</p>
              <p>Primeri:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>dovedeš određen broj prijatelja koji kupe aranžman,</li>
                <li>ideš dva puta sa Go2 u istoj godini,</li>
                <li>organizuješ veću ekipu na jednom putovanju,</li>
                <li>ideš i na zimovanje i na letovanje u roku od 12 meseci.</li>
              </ul>
              <p>Kada ispuniš uslov – otključavaš achievement i dobijaš dodatne poene, popuste ili šanse u nagradnoj igri.</p>
              <p>Aktuelnu listu achievement-a i nagrada Go2 objavljuje na sajtu i/ili u aplikaciji.</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">13. Kako funkcioniše referral program (preporuke)?</h2>
              <p>Dobijaš svoj referral kod (npr. preko naloga ili aplikacije) i:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>kada neko novi rezerviše i realizuje svoje prvo putovanje preko tog koda:</li>
                <li>novi putnik može dobiti popust ili poene dobrodošlice,</li>
                <li>ti dobijaš dodatne poene ili drugu pogodnost (npr. popust na sledeće putovanje).</li>
              </ul>
              <p>Tačni iznosi popusta i poena za preporuke biće jasno naznačeni u zvaničnoj komunikaciji Go2 (sajt, mreže, newsletter).</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">14. Da li postoji nagradna igra za gratis putovanje?</h2>
              <p>Go2 može periodično da organizuje nagradne igre u okviru programa “Go2 Legende” (npr. godišnje izvlačenje za gratis aranžman).</p>
              <p>Tipično:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>za svaku potrošnju (npr. svakih 50 EUR) dobijaš određeni broj šansi za izvlačenje,</li>
                <li>viši nivoi lojalnosti (Svetski putnik, Legenda) mogu imati više šansi po istom iznosu.</li>
              </ul>
              <p>Detaljna pravila svake nagradne igre (period trajanja, način izvlačenja, nagrade) biće objavljena posebno, pre početka te igre.</p>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">15. Kako mogu da proverim svoje poene i nivo?</h2>
              <p>Preko:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>korisničkog naloga na sajtu,</li>
                <li>mobilne aplikacije (ako postoji),</li>
                <li>ili kontaktom sa Go2 (email, telefon, filijala).</li>
              </ul>
              <p>Videćeš:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>trenutni broj poena,</li>
                <li>koliko vrede u evrima,</li>
                <li>svoj nivo (Putnik / Svetski putnik / Legenda),</li>
                <li>koliko ti nedostaje do sledećeg nivoa.</li>
              </ul>

              <h2 className="text-xl font-bold text-go2-pink mt-6 mb-3">16. Šta ako više ne želim da budem deo programa?</h2>
              <p>Uvek možeš:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>da zatražiš brisanje ili deaktivaciju svog naloga iz programa lojalnosti.</li>
              </ul>
              <p>U tom slučaju:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>svi neiskorišćeni poeni i pogodnosti prestaju da važe,</li>
                <li>ne mogu se preneti na drugog niti isplatiti u novcu.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
  );
};
